import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DialogRef } from '../../dialog-ref';

import { ConfirmationModalData } from './confirmation-modal-data';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
    constructor(public modalRef: DialogRef<boolean, ConfirmationModalData>) {}
}
